import { render, staticRenderFns } from "./MedicineForm.vue?vue&type=template&id=6fe7ae32&scoped=true&"
import script from "./MedicineForm.vue?vue&type=script&lang=ts&"
export * from "./MedicineForm.vue?vue&type=script&lang=ts&"
import style0 from "./MedicineForm.vue?vue&type=style&index=0&id=6fe7ae32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe7ae32",
  null
  
)

export default component.exports